class SkuArtifact {
  id = null;
  name = null;
  code = null;
  status = null;
  orgPrice = null;
  unitType = null;
  transactionStatus = null;

  constructor(data) {
      this.id = data.id ?? null;
      this.code = data.code ?? null;
      this.name = data.name ?? null;
      this.status = data.status ?? null;
      this.orgPrice = data.orgPrice ?? null;
      this.unitType = data.unitType ?? null;
      this.transactionStatus = data.transactionStatus ?? null;
  }
}

export default SkuArtifact;